const getCityString = (v) => `${v.name}, ${v.region}, ${v.country}`;

export default getCityString;
